import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import LocationTwoAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-two/location-two.entity";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Normalizers,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { ICreateLocationTwo } from "./interfaces/create-location-two.interface";
import { IUpdateLocationTwo } from "./interfaces/update-location-two.interface";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import LocationOneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-one/location-one.entity";

const apiUrl = env.API_LOCATION_URL;
const moduleName = "location_two";

@Injectable({
  providedIn: "root",
})
export class LocationTwoService extends AbstractService<
  LocationTwoAttributes,
  ICreateLocationTwo,
  IUpdateLocationTwo
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @param locationOneCodeList location-one codes filter
   * @param selectedStatuses selected statuses filter
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<LocationTwoAttributes>,
    locationOneCodeList: string[],
    selectedStatuses: number[]
  ): Observable<IPaginationResult<LocationTwoAttributes>> {

    const query = buildQuery<LocationTwoAttributes>(
      andWhere('_deleted', Ops.not(true)),
      options.search ? andWhere("code", Ops.like(options.search ?? "", "i")) : noop(),
      options.search ? orWhere("name", Ops.like(options.search ?? "", "i")) : noop(),
      locationOneCodeList && locationOneCodeList.length > 0 ? where('locationOne.code' as keyof LocationTwoAttributes, Ops.in(...locationOneCodeList)) : noop(),
      selectedStatuses && selectedStatuses.length > 0 ? where('statusId' as keyof LocationTwoAttributes, Ops.in(...selectedStatuses)) : noop(),
      orderBy(
        options.sort ?? "code",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<LocationTwoAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(locationOne?): Observable<IRequestResult<LocationTwoAttributes[]>> {
    const query = buildQuery<LocationTwoAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      locationOne ? andWhere('locationOne.code' as keyof LocationTwoAttributes, Ops.eq(locationOne)) : noop(),
      // locationId && locationId.length > 0 ? where('locationOne._id' as keyof LocationTwoAttributes, Ops.in(...locationId)) : noop(),
      //select(["code", "name"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<LocationTwoAttributes[]>>(API_URL);
  }
}
